var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { API } from 'globals/api';
import { RULE_ENGINE_END_POINTS } from 'globals/apiEndPoints';
import { APIMethod } from 'globals/enums';
export function getSeniorAlertsService(param) {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, API({
                    url: RULE_ENGINE_END_POINTS.GET_SENIOR_ALERTS,
                    method: APIMethod.Get,
                    params: param,
                })];
        });
    });
}
export var ALERT_STATUS = {
    ACTIVE: 'ACTIVE',
    ACKNOWLEDGED: 'ACKNOWLEDGED',
    DISMISSED: 'DISMISSED',
    RESOLVED: 'RESOLVED',
    ARCHIVED: 'ARCHIVED',
};
export var VALID_ALERT_TRANSITIONS = {
    ACTIVE: ['ACKNOWLEDGED', 'DISMISSED', 'RESOLVED'],
    ACKNOWLEDGED: ['DISMISSED', 'RESOLVED'],
    DISMISSED: ['RESOLVED'],
    RESOLVED: ['ARCHIVED'],
    ARCHIVED: [],
};
export var isValidAlertTransition = function (from, to) {
    var _a, _b;
    var fromKey = (from || 'ACTIVE').toUpperCase() in VALID_ALERT_TRANSITIONS
        ? (from || 'ACTIVE').toUpperCase()
        : 'ACTIVE';
    var toKey = to.toUpperCase();
    return (_b = (_a = VALID_ALERT_TRANSITIONS[fromKey]) === null || _a === void 0 ? void 0 : _a.includes(toKey)) !== null && _b !== void 0 ? _b : false;
};
export function fetchSeniorAlertsByStatus(seniorId_1) {
    return __awaiter(this, arguments, Promise, function (seniorId, status) {
        var response, alerts, list, filtered;
        var _a;
        if (status === void 0) { status = ALERT_STATUS.ACTIVE; }
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getSeniorAlertsService({ seniorId: seniorId, status: status.toLowerCase() })];
                case 1:
                    response = _b.sent();
                    alerts = ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.alerts) || (response === null || response === void 0 ? void 0 : response.data) || (response === null || response === void 0 ? void 0 : response.alerts) || response || [];
                    list = Array.isArray(alerts) ? alerts : [];
                    filtered = list.filter(function (a) { return !!((a === null || a === void 0 ? void 0 : a.message) || (a === null || a === void 0 ? void 0 : a.title) || (a === null || a === void 0 ? void 0 : a.rule_name)); });
                    if (status !== ALERT_STATUS.ACTIVE) {
                        return [2 /*return*/, filtered];
                    }
                    return [2 /*return*/, filtered.filter(function (a) {
                            var rawStatus = a === null || a === void 0 ? void 0 : a.status;
                            var effectiveStatus = rawStatus === null || rawStatus === undefined ? ALERT_STATUS.ACTIVE : String(rawStatus).toUpperCase();
                            return effectiveStatus === ALERT_STATUS.ACTIVE;
                        })];
            }
        });
    });
}
export var fetchActiveSeniorAlerts = function (seniorId) {
    return fetchSeniorAlertsByStatus(seniorId, ALERT_STATUS.ACTIVE);
};
export var RECENT_ALERTS_PAGE_SIZE = 20;
export function fetchRecentAlertsByStatus() {
    return __awaiter(this, arguments, Promise, function (status, page, limit, search) {
        var params, response, payload, list, alerts, total, hasMore;
        var _a, _b, _c, _d;
        if (status === void 0) { status = ALERT_STATUS.ACTIVE; }
        if (page === void 0) { page = 1; }
        if (limit === void 0) { limit = RECENT_ALERTS_PAGE_SIZE; }
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    params = {
                        status: status,
                        limit: limit,
                        offset: page - 1,
                    };
                    if (search === null || search === void 0 ? void 0 : search.trim())
                        params.seniorName = search.trim();
                    return [4 /*yield*/, getSeniorAlertsService(params)];
                case 1:
                    response = _e.sent();
                    payload = (_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : response;
                    list = (payload === null || payload === void 0 ? void 0 : payload.alerts) || (payload === null || payload === void 0 ? void 0 : payload.data) || payload;
                    alerts = Array.isArray(list) ? list : [];
                    total = (_d = (_c = (_b = payload === null || payload === void 0 ? void 0 : payload.total) !== null && _b !== void 0 ? _b : payload === null || payload === void 0 ? void 0 : payload.total_count) !== null && _c !== void 0 ? _c : payload === null || payload === void 0 ? void 0 : payload.count) !== null && _d !== void 0 ? _d : null;
                    hasMore = total !== null ? page * limit < total : alerts.length === limit;
                    return [2 /*return*/, { alerts: alerts, total: total, hasMore: hasMore }];
            }
        });
    });
}
export var ALERT_ACTION = {
    ACTIVE: 'ACTIVE',
    ACKNOWLEDGED: 'ACKNOWLEDGE',
    DISMISSED: 'DISMISS',
    RESOLVED: 'RESOLVE',
    ARCHIVED: 'ARCHIVE',
};
export function updateAlertStatusService(alertId, status) {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, API({
                    url: "".concat(RULE_ENGINE_END_POINTS.ALERT_STATUS, "/").concat(alertId),
                    method: APIMethod.Put,
                    data: { status: status },
                })];
        });
    });
}
export function updateAlertActionService(alertId, status) {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, API({
                    url: RULE_ENGINE_END_POINTS.GET_SENIOR_ALERTS,
                    method: APIMethod.Put,
                    data: { alertId: alertId, action: ALERT_ACTION[status] },
                })];
        });
    });
}
